// FLAG:useDocuAi — pure helper for the surgical single-row list patch used by the useDocuAi
// thumbnail/analysis refresh path. Kept dependency-free so it is unit-testable in isolation.
//
// Returns the SAME array reference when there is nothing to change (not an array, id not found,
// or no field actually differs), so the surgical-update path never triggers a needless re-render.
export const patchItemById = (items, fileId, patch) => {
  if (!Array.isArray(items)) return items
  const itemIndex = items.findIndex(({ id }) => id === fileId)
  if (itemIndex === -1 || !patch) return items

  const currentItem = items[itemIndex]
  const nextItem = { ...currentItem, ...patch }
  const changed = Object.keys(patch).some((key) => currentItem[key] !== nextItem[key])
  if (!changed) return items

  const updatedItems = [...items]
  updatedItems[itemIndex] = nextItem
  return updatedItems
}

// FLAG:useDocuAi — like patchItemById but DEEP-merges into the row's metaData instead of
// replacing top-level fields. Used to reflect the analysisInProgress flag straight from the
// FILE:ANALYSED websocket payload (no async /meta refetch), so the blinking AI badge appears
// the instant analysis starts — before the terminal review data (documentInvoiceDetails)
// lands and closes the ANALYZING gate. Returns the SAME array when nothing actually changes.
export const patchItemMetaById = (items, fileId, metaPatch) => {
  if (!Array.isArray(items)) return items
  const itemIndex = items.findIndex(({ id }) => id === fileId)
  if (itemIndex === -1 || !metaPatch) return items

  const currentItem = items[itemIndex]
  const currentMeta = currentItem.metaData || {}
  const changed = Object.keys(metaPatch).some((key) => currentMeta[key] !== metaPatch[key])
  if (!changed) return items

  const updatedItems = [...items]
  updatedItems[itemIndex] = { ...currentItem, metaData: { ...currentMeta, ...metaPatch } }
  return updatedItems
}
